const state = () => ({
  showFocus: false,
  inputtingText: false,
});

const getters = {
  showFocus: state => state.showFocus,
  inputtingText: state => state.inputtingText,
};

const mutations = {
  setShowFocus(state, showFocus) {
    state.showFocus = showFocus;
  },
  setInputtingText(state, inputtingText) {
    state.inputtingText = inputtingText;
  },
};

const actions = {
  setShowFocus({ commit }, showFocus) {
    commit('setShowFocus', showFocus);
  },
  setInputtingText({ commit }, inputtingText) {
    commit('setInputtingText', inputtingText);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
